import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { viewSignUpPopUpEvent } from 'src/Helpers/TagManager'
import { FirstChosenTrackParams } from 'src/Hooks/useFirstChosenTrack'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

export const useViewSignup = (
  fallbackPlatform?: CampaignPlatformTypeEnum,
): void => {
  const { platform: platformParam } = useParams<FirstChosenTrackParams>()
  const platform = platformParam || fallbackPlatform

  useEffect(() => {
    if (platform) {
      viewSignUpPopUpEvent({
        platformName: platform,
      })
    }
  }, [platform])
}
